export function selectOnFocusHandler(
  event: React.FocusEvent<HTMLInputElement>,
) {
  event.currentTarget.select();
}
